export default "__VITE_ASSET__Dcfe11IM__"